import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider,Select, Table, Modal, message, Form, Input, Switch, DatePicker } from 'antd'
import UploadQiniu from '../../commponents/uploadQiniu/index'
import update from 'react-addons-update';
import { DndProvider, DragSource, DropTarget } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import moment from 'moment';
const FormItem = Form.Item;
const { Option } = Select;
const {TextArea} = Input
let dragingIndex = -1; 
class BodyRow extends React.Component {
	render() {
		const { isOver, connectDragSource, connectDropTarget, moveRow, ...restProps } = this.props;
		const style = { ...restProps.style, cursor: 'move' };

		let { className } = restProps;
		if (isOver) {
			if (restProps.index > dragingIndex) {
				className += ' drop-over-downward';
			}
			if (restProps.index < dragingIndex) {
				className += ' drop-over-upward';
			}
		}

		return connectDragSource(
			connectDropTarget(<tr {...restProps} className={className} style={style} />),
		);
	}
}
const rowSource = {
	beginDrag(props) {
		dragingIndex = props.index;
		return {
			index: props.index,
		};
	},
};
const rowTarget = {
	drop(props, monitor) {
		const dragIndex = monitor.getItem().index;
		const hoverIndex = props.index;
		if (dragIndex === hoverIndex) {
			return;
		}
		props.moveRow(dragIndex, hoverIndex);
		monitor.getItem().index = hoverIndex;
	},
};
const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
	connectDropTarget: connect.dropTarget(),
	isOver: monitor.isOver(),
}))(
	DragSource('row', rowSource, connect => ({
		connectDragSource: connect.dragSource(),
	}))(BodyRow),
);
class Qscode extends Component {

	constructor(props) {
		super(props)
		this.state = {
			activityname: '',
			name: '',
			status: '',
			visible: false,
			token: '',
			url: '',
			modelTitel: '新增活动',
			coverUrl: '',
			dataSource: [],
			notChanged: [],
			qiuniuUrl: '',
			endTime: undefined,
			id: null,
			searchData: {
				total: 0,
				pageNum: 1,
				pageSize: 10
			},
			columns: [
				{
					title: '活动封面',
					dataIndex: 'coverUrl',
					key: 'coverUrl',
					align: 'center',
					render: (record)=> <img src={record} style={{width: '40px',height: '40px'}} alt=""/>
				},
				{
					title: '活动名称',
					dataIndex: 'name',
					key: 'name',
					align: 'center'
				},
				{
					title: '活动结束时间',
					dataIndex: 'endTime',
					key: 'endTime',
					align: 'center'
				},{
					title: '创建人',
					dataIndex: 'createName',
					key: 'createName',
					align: 'center'
				},
				{
					title: '创建时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				},
				{
					title: '发布状态',
					dataIndex: 'status',
					key: 'status',
					align: 'center',
					render: (record,text)=> {
						return (
							<div>
								<Switch defaultChecked={record === true ? true : false} key={record === true ? true : false} onChange={(checked) => {
									let id = text.id
									let arr = this.state.dataSource
									for(let i = 0; i<arr.length; i++){
										if(id === arr[i].id){
											arr[i].status = checked===true ? true : false
											this.setState({
												dataSource: arr
											})
										}
									}
									return (
										Modal.confirm({
											title: `${checked === true ? '发布活动' : '取消发布'}`,
											okText: "确定",
											cancelText: "取消",
											content: (
												<div>
													<p>{checked === true ? '发布后此活动将同步至用户端，请谨慎操作！确定要发布吗？' : '取消发布后用户端将不展示此活动，请谨慎操作！确定要取消发布吗？'}</p>
												</div>
											),
											onOk: () => {
												this.isRelease(id,checked,'ok')
											},
											onCancel: () => {
												this.isRelease(id,checked,'cancel')
											}
										})
									)
								}} />

							</div>
						)
					}
				},
				{
					title: '操作',
					key: 'operation',
					align: 'center',
					render: (record) => <div>
						{<span style={{marginRight:'15px',color: '#277FFF', cursor: 'pointer'}}  onClick={() => {
							this.setState({
								visible: true,
								modelTitel: '编辑活动',
								name: record.name,
								id: record.id,
								endTime: moment(record.endTime),
								jumpType: record.jumpType,
								jumpUrl: record.jumpUrl,
								jumpAppid: record.jumpAppid,
								preinstallNum: String(record.preinstallNum),
								coverUrl: {
									uid: null,
									type: null,
									url: record.coverUrl,
									name: record.name
								},

							})
						}}>编辑</span>}
						{record.status === false ? <span style={{color: '#277FFF', cursor: 'pointer'}} onClick={() => {
							Modal.confirm({
								title: '删除活动',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p>活动删除后将不可恢复，请谨慎操作！确定要删除吗？</p>
									</div>
								),
								onOk: () => {
									this.delQscode(record.id)
								},
							});
						}}>删除</span> : ''}
					</div>
				},
			]
		}
	}
	handleOk=(e)=> {
		this.props.form.validateFields((err, values) => {
			if(!err) {
				if(this.state.modelTitel === '编辑活动'){
					let pic = values.coverUrl.url&&values.coverUrl.url ? values.coverUrl.url :this.state.qiuniuUrl +'/'+ values.coverUrl.response.key
					axios.post('fictitiousActivityController/update',{
						name: values.name,
						coverUrl: pic,
						id: this.state.id,
						endTime: values.endTime.format('YYYY-MM-DD HH:mm:ss'),
						jumpType: values.jumpType,
						jumpUrl: values.jumpUrl,
						jumpAppid: values.jumpAppid,
						preinstallNum: values.preinstallNum,
					}).then( res => {
						if(res.data.code === '200') {
							this.setState({visible: false})
							message.success('修改成功')
							this.getList()
						}else{
							message.error(res.data.msg)
						}
					})
				}else {
					axios.post('fictitiousActivityController/add',{
						name: values.name,
						coverUrl: this.state.url +'/'+ values.coverUrl.response.key,
						endTime: values.endTime.format('YYYY-MM-DD HH:mm:ss'),
						jumpType: values.jumpType,
						jumpUrl: values.jumpUrl,
						jumpAppid: values.jumpAppid,
						preinstallNum: values.preinstallNum,
					}).then( res => {
						if(res.data.code === '200') {
							this.setState({visible: false})
							message.success('新增成功')
							this.getList()
						}else{
							message.error(res.data.msg)
						}
					})
				}
				
			}
		});
	}
	// 发布
	isRelease(id,checked,type) {
		if(type === 'ok'){
			axios.post('fictitiousActivityController/update',{
				id: id,
				status: checked === true ? true : false
			}).then( res => {
				if(res.data.code === '200') {
					message.success('操作成功')
					this.getList()
				}else {
					message.error(res.data.msg)
				}
			})
		}else if(type === 'cancel') {
			this.getList()
		}
	}
	componentDidMount() {
		this.getList()
		this.getToken()
	}
	disabledDate = (current) => {
		return current && current < moment().subtract(1, 'days')
	}
  downValidateForm = (rule, value, callback) => {
    if(value&&new Date(value).getTime()<=new Date().getTime()){
			callback('活动结束时间必须大于现在的时间')
		}else{
			callback()
		}
  }
	showModal() {
		this.setState({ 
			visible: true,
			modelTitel: '新增活动',
			coverUrl: '',
			jumpType: 1,
			jumpUrl: '',
			jumpAppid: '',
			preinstallNum: '',
		 })
	}
	async getList() {
		axios.post('fictitiousActivityController/getList',{
			...this.state.searchData,
			name: this.state.activityname,
			status: this.state.status,
		}).then( res => {
			if(res.data.code === '200'){
				this.setState({
					dataSource: res.data.data.list,
					notChanged: res.data.data.list,
					searchData: {
						pageNum: res.data.data.pageNum,
						pageSize: res.data.data.pageSize,
						total: res.data.data.total
					}
				})
			}
		})
	}
	delQscode(id) {
		axios.post(`fictitiousActivityController/del/${id}`).then( res => {
			if(res.data.code === '200'){
				message.success('删除成功')
				this.getList()
			}else {
				message.error(res.data.msg)
			}
		})
	}
	getToken() {
		let _this = this;
		axios.get("/uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token: res.data.data.token,
					url: res.data.data.url
				})
				// this.props.getQiniuUrl(res.data.data.url)
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
	getQiniuUrl = v => {
		this.setState({
			qiuniuUrl: v
		})
	}
	components ={
		body: {
			row: DragableBodyRow,
		},
	};
	moveRow = (dragIndex, hoverIndex) => { 
		const { dataSource } = this.state;
		const dragRow = dataSource[dragIndex];
		this.setState(
			update(this.state, {
				dataSource: {
					$splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
				},
			}),
		);
	
		let oldSort = []
		for (let i = 0; i < this.state.notChanged.length; i++) {
			oldSort.push({ sort: this.state.notChanged[i].sort, id: this.state.dataSource[i].id })
		}
		axios.post('/fictitiousActivityController/updateSort',oldSort).then(res => {
			if(res.data.code === '200' ){
				this.getList()
				message.success('更新排序成功')
			}else {
				message.error(res.data.msg)
			}
			oldSort = []
		})
	};
	render() {
		
		const { visible, dataSource, columns, modelTitel, coverUrl,activityname, name, status, searchData,endTime, jumpType,jumpUrl, jumpAppid, preinstallNum } = this.state;
		const { getFieldDecorator } = this.props.form
		const { form } = this.props;
		const pagination ={
			showSizeChanger: true,
			total: searchData.total,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal:() => `共 ${searchData.total} 条`,
			onShowSizeChange: (current,pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.getList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.getList(searchData)
			},
		}
		return (
			<div>
				<span style={{display: 'flex', alignItems: 'center',fontSize: '18px',fontWeight: '600'}}>活动管理</span>
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between',marginBottom: '20px' }}>
					<div>
						<Input allowClear value={activityname} style={{width: '260px',height: '40px',marginRight: '20px'}} placeholder="请输入活动名称" onChange={(e)=>{
							this.setState({
								activityname: e.target.value
							})
						}}></Input>
						<Select  placeholder="活动状态" size={'large'} value={status} allowClear style={{ width: 260, height: '40px', marginRight: '20px' }} onChange={(value)=>{
							this.setState({
								status: value
							})
						}}>
							<Option value="">全部</Option>
							<Option value={true}>已发布</Option>
							<Option value={false}>未发布</Option>
						</Select>
						<Button className='my-button-primary' style={{marginRight: '20px'}} onClick={()=>{
							this.getList()
						}} type='primary'>搜索</Button>
						<span className='my-button-txt' onClick={()=>{
							this.setState({activityname: '', status: ''},()=>{
								this.getList()
							})
						}} type='primary'>重置</span>
					</div>
					<Button className='my-button-primary' type='primary'  onClick={() => { this.showModal() }}>新增活动</Button>
				</div>
				<DndProvider backend={HTML5Backend}>
					<Table pagination={pagination} dataSource={dataSource} 
						columns={columns} 
						components={this.components}
						rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')} 
						rowKey={record => record.id}
						onRow={(record, index) => ({
							index,
							moveRow: this.moveRow,
						})}	
					/>
				</DndProvider>
				<Modal
					getContainer={false}
					title={modelTitel}
					okText="确认"
					cancelText="取消"
					visible={visible}
					maskClosable={false}
					destroyOnClose
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
				>
					<Form labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} onSubmit={this.handleOk}>
						<FormItem label={"活动名称"}>
							{getFieldDecorator('name', {initialValue: modelTitel==='编辑活动'? name: '',
								rules: [{ required: true, message: '请输入活动名称!' },{max: 50, message: '最多输入50个字符'}],
							})(
								<Input allowClear placeholder='请输入活动名称' />
							)}
						</FormItem>
						<Form.Item label="活动封面">
							{getFieldDecorator('coverUrl', {
								initialValue: modelTitel==='编辑活动'? coverUrl: '',
								rules: [{ required: true, message: '请上传活动封面!' }],
							})(
									<UploadQiniu getQiniuUrl={this.getQiniuUrl}/>
							)}
						</Form.Item>
						<Form.Item label="活动结束时间：">
							{getFieldDecorator("endTime", {
								rules: [
									{ required: true, message: "请选择活动结束时间！" },
									{ validator: this.downValidateForm }
								],
								initialValue: modelTitel === '编辑活动'? endTime : undefined
							})(
								<DatePicker
									showTime
									format="YYYY-MM-DD HH:mm:ss"
									placeholder="请选择活动结束时间"
									disabledDate={this.disabledDate}
									style={{ width: '100%' }}
								/>
							)}
						</Form.Item>
						<Form.Item label="跳转类型">
							{getFieldDecorator('jumpType', {
								rules: [{ required: true, message: '请选择跳转类型' }],
								initialValue: modelTitel==='编辑活动'? jumpType: jumpType
							})(
								<Select
									placeholder="请选择跳转类型"
								>
									<Option value={1}>小程序内部跳转</Option>
									<Option value={2}>公众号跳转</Option>
									<Option value={3}>第三方小程序跳转</Option>
								</Select>
							)}
						</Form.Item>
						<FormItem label={"跳转链接"}>
							{getFieldDecorator('jumpUrl',{
							initialValue: modelTitel==='编辑活动'? jumpUrl: '',
							rules: [{required: true, max: 200, message: '请输入跳转链接'}]
						})(
								<TextArea style={{width: '100%'}}  placeholder='请输入跳转链接' />
							)}
						</FormItem>
						<FormItem label={"小程序APPID"} style={{display: form.getFieldValue('jumpType') === 3 ?'block':'none'}}>
							{getFieldDecorator('jumpAppid',{
							initialValue: modelTitel==='编辑活动'? jumpAppid: '',
							rules: [{max: 200, required: form.getFieldValue('jumpType') === 3 ? true : false, message: '请输入小程序APPID'}]
						})(
								<Input style={{width: '100%'}}  placeholder='请输入小程序APPID' />
							)}
						</FormItem>
						<FormItem label={"预设参与人数"}>
							{getFieldDecorator('preinstallNum',{
							initialValue: modelTitel==='编辑活动'? preinstallNum: '',
							rules: [{max: 200,required: false, message: '最多输入200个字符'}]
						})(
								<Input style={{width: '100%'}}  placeholder='请输入预设浏览人数' />
							)}
						</FormItem>
					</Form>
				</Modal>
			</div>
		)
	}
}

export default Form.create()(Qscode)
